import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Typography, Chip, Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: theme.spacing(3),
      display: 'flex'
    },
    titleContainer: {
      display: 'flex'
    },
    productName: {
      color: '#696969'
    },
    chip: {
      height: 18,
      textTransform: 'uppercase',
      fontWeight: 400,
      fontSize: 14,
      borderRadius: 2,
      color: 'white',
      backgroundColor: '#1A7034'
    },
    jumpIntoInformationContainer: {
      background: '#E0EFFF',
      borderRadius: 4,
      padding: theme.spacing(1) * 1.5,
      width: 380
    },
    otherInformationContainer: {
      background: '#EAEAEA',
      borderRadius: 4,
      padding: theme.spacing(1) * 1.5,
      width: 380,
      marginTop: 8
    },
    informationHeader: {
      fontWeight: 500
    },
    informationSubtitle: {
      fontWeight: 400
    },
    colorBoxContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(3)
    },
    imgBox: {
      height: 80,
      width: 80,
      borderRadius: 8
    }
  };
});
type Props = {
  title?: string;
  chip?: { backgroundColor?: string; text: string };
  subtitle?: string;
  imageSrc?: string;
};
const PreviewListHeaderContainer: React.FC<Props> = ({
  children,
  title,
  chip,
  subtitle,
  imageSrc
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <Grid container justify="space-between">
        <Grid container item direction="row" xs={12} md={6}>
          <Box className={classes.titleContainer}>
            {imageSrc && (
              <Grid item className={classes.colorBoxContainer}>
                <img src={imageSrc} className={classes.imgBox} alt="Week Thumbnail" />
              </Grid>
            )}
            <Grid container item direction="column">
              {chip && (
                <Grid item>
                  <Chip
                    size="small"
                    label={chip?.text}
                    className={classes.chip}
                    style={{ backgroundColor: chip.backgroundColor }}
                  />
                </Grid>
              )}
              {title && (
                <Grid item>
                  <Typography variant="h1">{title}</Typography>
                </Grid>
              )}
              {subtitle && (
                <Grid item>
                  <Typography variant="subtitle1" className={classes.productName}>
                    {subtitle}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
        {children}
      </Grid>
    </Paper>
  );
};

export default PreviewListHeaderContainer;
